<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Imagens - Álbuns e acessórios
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="justify-center align-center"> </v-row>

          <v-row class="justify-center">
            <v-col cols="12" md="10">
            <table style="width: 100%;">
              <tr style="font-weight: bold; background: grey;">
                <th style="width: 8%;">IMG</th>
                <th style="width: 37%;">Nome</th>
                <th style="width: 55%;">URL (caminho)</th>
              </tr>
              <tr v-for="(item, i) in img_list" :key="i" class="linha">
                <td class="img-center">
                  <img v-if="item.url" style="width:40px; height:40px" :src="item.url" />
                  <img v-else style="width:40px; height:40px" src="../assets/sem_img.jpg" />
                </td>
                <td class="coluna1">{{ item.nome }}</td>
                <td class="coluna1">
                  <v-text-field
                    dense
                    hide-details
                    class="url-img"
                    v-model="item.url"
                  ></v-text-field>
                </td>
              </tr>
            </table>
          </v-col>
          </v-row>

          <v-row class="justify-center">
            <v-col cols="12">
              <v-row> </v-row>
              <v-row class="justify-center my-8">
                <v-btn
                  small
                  color="primary"
                  class="mx-2"
                  rounded
                  @click="salvar()"
                  >salvar</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="alert = false">
          X
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "imagem-admin",
  computed: {
    imagens() {
      return this.$store.getters.imagens;
    },
  },
  watch: {
    imagens(a) {
      this.img_list = a
    }
  },
  mounted() {
    this.img_list = this.imagens;
  },
  data() {
    return {
      img_list: [],
      alert: false,
      msg: ""
    };
  },
  methods: {
    salvar() {
      const obj = this.img_list
      this.$store.dispatch("setImagens", obj)
      this.showAlert()
    },
    showAlert() {
      this.msg = "Salvo com sucesso!!";
      this.alert = true;
    },
  },
};
</script>

<style scoped>
.img-center{
  text-align: center;
}
.coluna1 {
  text-align:left;
  border-bottom: solid 1px #000;
  padding-left: 5px;
}
.linha{
  height: 40px;
}
.linha:nth-child(even) {
  background-color: #f2f2f2;
}
.linha:nth-child(odd) {
  background-color: #ffffff;
}
.url-img{
  padding-left: 5px;
}
</style>
